import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '@utils/apiRequest'
import Emitter from '@utils/eventEmitter'

export const adminGetGroupList = createAsyncThunk(
  'ADMIN_GET_GROUP_LIST',
  async (params) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/group`,
      params
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return {
      data: response,
    }
  }
)

export const adminGetCompanyList = createAsyncThunk(
  'ADMIN_GET_COMPANY_LIST',
  async (params) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/company`,
      params
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return {
      data: response,
    }
  }
)

export const createCompany = createAsyncThunk(
  'CREATE_REPORT',
  async (data) => {
    let options = {
      method: 'POST',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/company`,
      data
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return {
      data
    }
  }
)

export const updateCompany = createAsyncThunk(
  'UPDATE_COMPANY',
  async (data) => {
    let options = {
      method: 'PUT',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/company/${data.companyId}`,
      data
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return {
      data
    }
  }
)

export const deleteCompany = createAsyncThunk(
  'DELETE_COMPANY',
  async (data) => {
    let options = {
      method: 'DELETE',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/company/${data.companyId}`,
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return {
      data
    }
  }
)

export const deleteSelectedCompany = createAsyncThunk(
  'DELETE_SELECTED_COMPANY',
  async (data) => {
    let response = await Promise.all(data.selecteds.map(companyId => (
      apiRequest({
        method: 'DELETE',
        url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/company/${companyId}`,
      })
    )))
    if (response.__isError) { return }
    return {
      data
    }
  }
)

export const adminGetCompanyNameList = createAsyncThunk(
  'ADMIN_GET_COMPANY_NAME_LIST',
  async () => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/company/name`
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return response
  }
)

export const adminGetCompanyWithExcel = createAsyncThunk(
  'ADMIN_GET_COMPANY_WITH_EXCEL',
  async (data) => {
    let options = {
      method: 'POST',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/company/excel`,
      data,
      responseType: 'blob',
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return {
      data: response,
      param: data,
    }
  }
)

const adminCompanySlice = createSlice({
  name: 'adminCompany',
  initialState: {
    isLoading: false,
    groupList: [],
    companyList: [],
    companyListTotalSize: 0,
    companyNameList: [],
  },
  reducers: {
    clearGroupList: (state) => {
      state.groupList = []
    },
    clearCompanyList: (state) => {
      state.companyList = []
      state.companyListTotalSize = 0
    },
    clearCompanyNameList: (state) => {
      state.companyNameList = []
    },
  },
  extraReducers: {
    [adminGetCompanyList.pending]: (state) => {
      state.isLoading = true
    },
    [adminGetCompanyList.rejected]: (state) => {
      state.isLoading = false
    },
    [adminGetCompanyList.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.companyListTotalSize = payload.data.totalElements
      state.companyList = payload.data.content
    },
    [adminGetGroupList.fulfilled]: (state, { payload }) => {
      state.groupList = payload.data
    },
    [createCompany.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }

      Emitter.emit('SHOW_MESSAGE', {
        text: `등록되었습니다.`
      })

      state.companyListTotalSize += 1
    },
    [updateCompany.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }

      Emitter.emit('SHOW_MESSAGE', {
        text: `변경되었습니다.`
      })

      state.companyList = state.companyList.map(company => {
        if (company.companyId === payload.data.companyId) {
          return payload.data
        } else {
          return company
        }
      })
    },
    [deleteCompany.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }

      Emitter.emit('HIDE_CONFIRM')
      Emitter.emit('SHOW_MESSAGE', {
        text: '삭제되었습니다.'
      })

      state.companyList = state.companyList.filter(company => company.companyId !== payload.data.companyId)
      state.companyListTotalSize -= 1
    },
    [deleteSelectedCompany.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }

      Emitter.emit('HIDE_CONFIRM')
      Emitter.emit('SHOW_MESSAGE', {
        text: `${payload.data.selecteds.length}개 삭제되었습니다.`
      })

      state.companyList = state.companyList.filter(company => !payload.data.selecteds.includes(company.companyId + ''))
    },
    [adminGetCompanyNameList.fulfilled]: (state, { payload }) => {
      state.companyNameList = payload
    },
    [adminGetCompanyWithExcel.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }

      const url = window.URL.createObjectURL(new Blob([payload.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `member_excel[company].xlsx`) //or any
      // other extension
      document.body.appendChild(link)
      link.click()
      setTimeout(() => {
        link.parentNode.removeChild(link)
      })

      Emitter.emit('SHOW_MESSAGE', {
        text: `파일이 다운로드되었습니다.`
      })
    },
  }
})

export const { clearCompanyList, clearCompanyNameList } = adminCompanySlice.actions

export default adminCompanySlice.reducer